module.exports = __webpack_public_path__ + "static/conseils-cc12b2f355d5827105f33c17cec081ae.svg";